/**
 * Reload the current page.
 *
 * If the window, window location, or reload function cannot be accessed,
 * this is a no-op.
 */
export const reload = (): void => {
    if (typeof window !== "undefined") {
        /* eslint-disable-next-line no-restricted-syntax
           --
           This is a permitted used of `window.location` access in our codebase.
           We need to be able to call the `reload` function here.
         */
        window.location?.reload?.();
    }
};
